(ns minorodata.connections.sources.famly
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "famly"
   :enabled      false
   :name         "Famly (Deprecated)"
   :description  "Save hours by replacing your spreadsheets, emails and fiddly software with Famly"
   :image-source "famlyLogo-big.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [name description username password organization-id]} data]
        {:source-type "famly"
         :name        name
         :description description

         :source
         {:credentials         {:type                   "password"
                                :username               username
                                :password               password}
          :organization-id     organization-id}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials organization-id]} source]
        (merge
         (select-keys credentials [:username :password])
         {:name              name
          :description       description
          :organization-id   organization-id})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :famly-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Organization ID"
              :name       :organization-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Username"
              :name       :username
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Password"
              :required   true
              :name       :password
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :famly-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Children"  :value "children"}
                           {:name "Child Attendance" :value "child-attendance"}
                           {:name "Employees" :value "employees"}
                           {:name "Incidents" :value "incidents"}
                           {:name "Invoices"  :value "invoices"}
                           {:name "Invoice Line Items" :value "invoice-lines"}
                           {:name "Invoicing" :value "invoicing"}
                           {:name "Occupancy" :value "occupancy"}
                           {:name "Payments"  :value "payments"}
                           {:name "Plans"     :value "plans"}]
              :required   true
              :value      "employees"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
